import React from "react";
import { Navigate } from "react-router-dom";
import { roleDashboardMap } from "./role-dashboard-map"; // import from dashboard-map.js in same folder

const DashboardRouter = () => {
  const user = getUserFromStorage();

  if (!user) return <Navigate to="/login" />;

  const DashboardComponent = getDashboardComponentByRole(user.role);

  if (!DashboardComponent) {
    return (
      <div className="text-center mt-10 text-red-500 font-semibold">
        No dashboard found for role: <strong>{user.role}</strong>
      </div>
    );
  }

  return <DashboardComponent />;
};

export default DashboardRouter;

//  Helpers

function getUserFromStorage() {
  const stored = localStorage.getItem("user");
  try {
    return stored ? JSON.parse(stored) : null;
  } catch {
    return null;
  }
}

function getDashboardComponentByRole(role) {
  if (!role) return null;
  const normalizedRole = role.trim().toLowerCase();
  return roleDashboardMap[normalizedRole] || null;
}
